import type { BorrowMarketDetail, BorrowMarketPair } from '@/utils/internalAppSdk'

export const getBorrowMarketCollateralAsset = (market: BorrowMarketDetail, pair: BorrowMarketPair | undefined) =>
  pair ? market.assetsData.find((assetData) => assetData.marketAssetId === pair.collateralMarketAssetId) : undefined
